module.exports = __webpack_public_path__ + "static/media/Resume of Hannan_Uddin new.adafeb5f.pdf";